import { Fragment, useMemo } from "react";

import { iconMap } from "./indexedList.constants";

import IndexedSection from "./IndexedSection";

import type { IndexedListProps } from "./indexedList.types";

import s from "./indexedList.module.scss";

const IndexedList = <T,>({
  letterItems,
  items,
  getNameItem,
  getLinkItem
}: IndexedListProps<T>) => {
  const sections = useMemo(
    () =>
      letterItems.map((letter) => {
        const itemsForLetter = items.filter((item) =>
          getNameItem(item).toLowerCase().startsWith(letter)
        );
        const icon = iconMap[letter];

        return {
          letter,
          icon,
          items: itemsForLetter
        };
      }),
    [letterItems, items, getNameItem]
  );

  return (
    <div className={s.wrapper}>
      {sections.map(({ letter, icon, items: sectionItems }, index) => (
        <Fragment key={letter}>
          <IndexedSection
            icon={icon}
            letter={letter}
            items={sectionItems}
            getNameItem={getNameItem}
            getLinkItem={getLinkItem}
          />
          {index < sections.length - 1 && <hr className={s.line} />}
        </Fragment>
      ))}
    </div>
  );
};

export default IndexedList;
